<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div ref="totalRef" class="subpage">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" title="预约咨询" :is-sub-page="true">
    </Header>
    <div ref="contentRef" class="form-content">
      <div style="padding-bottom: 25.4%; height: 0; margin-top: 20px; margin-bottom: 40px">
        <img src="@/assets/images/backgrounds/bg-yyzx.png" alt="pic" class="bg-img"/>
      </div>
      <Form
        :models="model"
        :formFields="fields"
        :items="items"
        btnMsg="提交咨询"
        @submitClick="submitConsultation">
      </Form>
    </div>
  </div>
</template>

<script>
import Form from '../../components/Form'
import Header from '@/components/Header'
import { query } from '@/api/query'

export default {
  name: 'Consultation',
  components: {
    Header,
    Form
  },
  data () {
    return {
      model: {
        name: '', // 姓名
        gender: '', // 性别
        birthdayType: '', // 日期类型
        birthday: '', // 出生日期
        phoneNum: '', // 手机
        content: '', // 咨询事项
        userValue: ''
      },
      items: ['input', 'radio', 'radio', 'date', 'input', 'textarea', 'button', 'userradio'],
      fields: [
        {
          type: 'input',
          modelKey: 'name',
          label: '姓名',
          props: {
            placeholder: '请输入姓名'
          },
          rules: {
            required: true
          },
          messages: {
            required: '请输入姓名'
          }
        },
        {
          type: 'radio-group',
          modelKey: 'gender',
          label: '性别',
          props: {
            options: ['男', '女'],
            horizontal: true,
            hollowStyle: true
          }
        },
        {
          type: 'radio-group',
          modelKey: 'birthdayType',
          label: '日期类型',
          props: {
            options: ['阳历', '阴历'],
            horizontal: true,
            hollowStyle: true
          }
        },
        {
          type: 'input',
          modelKey: 'birthday',
          label: '出生日期',
          props: {
            placeholder: '请输入出生日期',
            disabled: true
          }
        },
        {
          type: 'input',
          modelKey: 'phoneNum',
          label: '手机',
          props: {
            placeholder: '请输入手机号码'
          },
          rules: {
            required: true,
            type: 'tel'
          },
          messages: {
            required: '请输入手机号码'
          }
        },
        {
          type: 'input',
          modelKey: 'content',
          label: '咨询事项',
          props: {
            placeholder: '请输入咨询事项'
          }
        },
        {
          type: null
        },
        {
          type: 'radio-group',
          modelKey: 'userValue',
          props: {
            options: ['我已阅读并同意《用户隐私协议》'],
            horizontal: true,
            hollowStyle: true
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  mounted () {
    document.title = '预约咨询'
    if (this.$route.query && this.$route.query.token) {
      this.$store.commit('setInfo', { token: this.$route.query.token })
    }
  },
  methods: {
    submitConsultation () {
      query({
        name: this.model.name,
        gender: this.model.gender ? (this.model.gender === '男' ? '0' : '1') : '',
        birthday: this.model.birthday ? (this.model.birthday.replace('年', '-')
          .replace('月', '-')
          .replace('日', '')
          .replace('时', '')) : '',
        birthdayType: this.model.birthdayType ? (this.model.birthdayType === '阳历' ? '0' : '1') : '',
        phoneNum: this.model.phoneNum,
        content: this.model.content
      }
      ).then((res) => {
        if (res.code === 200) {
          this.$createToast({
            txt: '提交成功',
            type: 'txt'
          }).show()
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped src="@/style/form.styl">
</style>

<style lang="stylus" scoped>
.subpage
  background url("~@/assets/images/backgrounds/bg.png") no-repeat center
  background-size 100% 100%
</style>

<style lang="stylus">
body
  background-color #EFE9E0
</style>
